import { OrderDrawerForm } from './OrderDrawerForm';
import { OrderDrawerMultiForm } from './OrderDrawerForm/OrderDrawerMultiForm';
import '../../../styles/drawer';
import '../../../styles/drawer.css';
import type { FC } from 'react';

interface OrderDrawerViewProps {
  selectedOrders: number[];
  close: () => void;
}

export const OrderDrawerView: FC<OrderDrawerViewProps> = ({ selectedOrders, close }) => {
  if (selectedOrders.length === 1) {
    const orderId = selectedOrders[0];
    return <OrderDrawerForm key={orderId} orderId={orderId} close={close} />;
  }

  if (selectedOrders.length > 1) {
    return (
      <OrderDrawerMultiForm
        key={selectedOrders.join('-')}
        orderIds={selectedOrders}
        close={close}
      />
    );
  }
  return null;
};
